import { isApp } from "../native/platform";
import { openExternal } from "../native/openExternal";
import { upgradePlanRoute } from "./planRoute";
import { openUpgradeModal } from "./upgradeModal";

export const WEB_BILLING_URL = "https://anyhomes.fr/billing";

/**
 * Action « Gérer mon abonnement ».
 * - App native (iOS) : aucun achat d'abonnement in-app (règle Apple 3.1.1) →
 *   on sort de l'app pour gérer l'abonnement sur la version web.
 * - Web : comportement habituel (route d'upgrade selon le type de compte).
 */
export const manageSubscription = (navigate, user, meta) => {
  if (isApp()) {
    openExternal(WEB_BILLING_URL);
    return;
  }
  // Web : modale contextualisée (essai gratuit ou évolution d'abonnement).
  if (meta) {
    openUpgradeModal(meta);
    return;
  }
  openUpgradeModal(() => {
    if (navigate) navigate(upgradePlanRoute(user?.role, user?.accountType));
  });
};

/**
 * Accès DIRECT à l'écran d'abonnement adapté au type d'utilisateur, sans
 * modale intermédiaire (ex : boutons « Changer de plan » / « Changer
 * d'abonnement »).
 * - App native (iOS) : sortie vers la gestion d'abonnement web (règle Apple).
 * - Web : navigation vers /upgrade-plan (ou /pro-offers selon le type de compte).
 */
export const goToUpgradePlan = (navigate, user) => {
  if (isApp()) {
    openExternal(WEB_BILLING_URL);
    return;
  }
  if (navigate) navigate(upgradePlanRoute(user?.role, user?.accountType));
};
